import React, { forwardRef } from 'react'
import ObrysIkony from './ObrysIkony'

/**
 * Moduł fotowoltaiczny: panel z ogniwami w lekkiej perspektywie, na nóżce. Zamiast słońca (SunIcon),
 * które właściciel uznał 2026-10-09 za zbyt ogólne. Siatka 3x2, żeby przy 16 px ogniwa nie zlały się w plamę.
 */
const IkonaModulu = forwardRef((props, ref) => (
  <ObrysIkony ref={ref} {...props}>
    <path d='M5.625 3.75h12.75l2.625 10.5H3l2.625-10.5Z' />
    <path d='M9.75 3.75 9 14.25M14.25 3.75 15 14.25M4.313 9h15.374' />
    <path d='M12 14.25v4.5M8.25 18.75h7.5' />
  </ObrysIkony>
))

export default IkonaModulu
